import React, { useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { webSocketUrl } from "../../../configuration/Utils/constService";

const ComportMqttListener = ({ onMessage }) => {
  const clientRef = useRef(null);

  useEffect(() => {
    if (clientRef.current) {
      console.log("Already connected, skipping re-init");
      return;
    }

    const client = new Client({
      webSocketFactory: () => new SockJS(`${webSocketUrl}/ws`),
      reconnectDelay: 5000,
      debug: (str) => console.log("[STOMP]", str),
      onConnect: () => {
        console.log("Connected to WebSocket");

        client.subscribe(`/topic/comport-listening`, (message) => {
          const body = JSON.parse(message.body);
          console.log("Received:", body);
          if (onMessage) onMessage(body);
        });
      },
      onDisconnect: () => {
        console.log("STOMP disconnected");
      },
      onStompError: (frame) => {
        console.error("Broker error:", frame.headers["message"]);
      },
    });

    client.activate();
    clientRef.current = client;

    return () => {
      if (clientRef.current) {
        console.log("Disconnected WebSocket");
        clientRef.current.deactivate();
        clientRef.current = null;
      }
    };
  }, []);

  return null;
};

export default ComportMqttListener;
